export default __webpack_public_path__ + "static/media/doctorApp.03e6f7c9.png";